module.exports = __webpack_public_path__ + "static/media/cloud_bg.88b1adaa.png";